import { Component } from '@angular/core';
import {TranslocoPipe, TranslocoService} from '@jsverse/transloco';
import { NgClass } from '@angular/common';
import {RouterLink} from '@angular/router';
import {AnalyticsService} from '../../../../core/services/analytics/analytics.service';

@Component({
  selector: 'app-landing-pricing',
  imports: [
    NgClass,
    RouterLink,
    TranslocoPipe
  ],
  templateUrl: './landing-pricing.component.html',
  styleUrl: './landing-pricing.component.scss'
})
export class LandingPricingComponent {
  pricingPlans: any = [];

  public constructor(
    private readonly analytics: AnalyticsService,
    private readonly transloco: TranslocoService,
  ) {
    this.pricingPlans = [
      {
        name: 'plan.starter.name',
        price: this.transloco.translate('pricing.free'),
        frequency: this.transloco.translate('pricing.forever'),
        mostPopular: false,
        description: 'plan.starter.description',
        trackingName: 'Starter',
        expanded: false,
        advantages: [
          { key: 'pricing.advantages.public_page', icon: 'fa-pager' },
          { key: 'pricing.advantages.online_booking', icon: 'fa-calendar-check' },
          { key: 'pricing.advantages.stripe_payment', icon: 'fa-credit-card' },
          { key: 'pricing.advantages.auto_invoices', icon: 'fa-file-invoice' },
          { key: 'pricing.advantages.gallery_delivery', icon: 'fa-images' },
          { key: 'pricing.advantages.photo_storage_30d', icon: 'fa-archive' },
          { key: 'pricing.advantages.unlimited_clients_bookings', icon: 'fa-users' },
          { key: 'pricing.advantages.web_mobile_access', icon: 'fa-mobile-alt' },
        ]
      },
      {
        name: 'plan.pro.name',
        price: '39,99€',
        frequency: this.transloco.translate('pricing.per_month'),
        mostPopular: true,
        description: 'plan.pro.description',
        trackingName: 'Pro',
        expanded: false,
        advantages: [
          { key: 'pricing.advantages.public_page', icon: 'fa-pager' },
          { key: 'pricing.advantages.online_booking', icon: 'fa-calendar-check' },
          { key: 'pricing.advantages.stripe_payment', icon: 'fa-credit-card' },
          { key: 'pricing.advantages.auto_invoices', icon: 'fa-file-invoice' },
          { key: 'pricing.advantages.gallery_delivery', icon: 'fa-images' },
          { key: 'pricing.advantages.photo_storage_365d', icon: 'fa-archive' },
          { key: 'pricing.advantages.unlimited_clients_bookings', icon: 'fa-users' },
          { key: 'pricing.advantages.web_mobile_access', icon: 'fa-mobile-alt' },
          { key: 'pricing.advantages.stats', icon: 'fa-chart-line' },
          { key: 'pricing.advantages.custom_domain', icon: 'fa-link' },
          { key: 'pricing.advantages.marketplace_featured', icon: 'fa-star' },
          { key: 'pricing.advantages.verified_badge', icon: 'fa-certificate' },
          { key: 'pricing.advantages.priority_support', icon: 'fa-headset' }
        ]
      }
    ];
  }

  public clickPlan(plan: string): void {
    this.analytics.clickCta(
      'tryPlan' + plan,
      'landing_photographer',
    );
  }

  public toggleExpand(plan: any): void {
    plan.expanded = !plan.expanded;
  }
}
